import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DisabledGeographicMenu } from 'shell/view-models/disabled-menu';

interface GeographicMenuProps {
  visibility?: DisabledGeographicMenu;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const GeographicMenu = ({
  visibility = {
    municipality: true,
    region: true,
    province: true,
    state: true,
    territory: true,
    consulate: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: GeographicMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle Geografiche" />
      </ListItem>
      <Menu
        id="geographic-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '20ch',
          },
        }}
      >
        {visibility.municipality
          ? [
              <MenuItem
                key="comune-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/comune');
                }}
              >
                <Typography variant="inherit">Comuni</Typography>
              </MenuItem>,
              <Divider key="comune-divider" hidden={!visibility.region} />,
            ]
          : undefined}
        {visibility.province
          ? [
              <MenuItem
                key="provincia-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/italia/provincia');
                }}
              >
                <Typography variant="inherit">Province</Typography>
              </MenuItem>,
              <Divider key="provincia-divider" hidden={!visibility.state} />,
            ]
          : undefined}
        {visibility.region
          ? [
              <MenuItem
                key="regione-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/italia/regione');
                }}
              >
                <Typography variant="inherit">Regioni</Typography>
              </MenuItem>,
              <Divider key="regione-divider" hidden={!visibility.province} />,
            ]
          : undefined}
        {visibility.state
          ? [
              <MenuItem
                key="statoEstero-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/estero/stato');
                }}
              >
                <Typography variant="inherit">Stati Esteri</Typography>
              </MenuItem>,
              <Divider key="statoEstero-divider" hidden={!visibility.consulate} />,
            ]
          : undefined}
        {visibility.consulate
          ? [
              <MenuItem
                key="consolato-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/estero/consolato');
                }}
              >
                <Typography variant="inherit">Consolati</Typography>
              </MenuItem>,
              <Divider key="territorio-divider" hidden={!visibility.territory} />,
            ]
          : undefined}
        {visibility.territory
          ? [
              <MenuItem
                key="territorio-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/sistema/geografiche/estero/territorio');
                }}
              >
                <Typography variant="inherit">Territori</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

GeographicMenu.displayName = 'Geographic Menu';

export default GeographicMenu;
